import type { ReactNode } from 'react';
import { useApp, type ScreenId } from '../state/store';
import { useTheme } from '../hooks/useTheme';

type Props = {
  title?: string;
  backTo?: ScreenId;
  right?: ReactNode;
  compact?: boolean;
};

export function NavBar({ title, backTo, right, compact = false }: Props) {
  const setScreen = useApp((s) => s.setScreen);
  const { theme, toggle } = useTheme();

  return (
    <div className={`nav-bar${compact ? ' nav-bar--compact' : ''}`}>
      {backTo !== undefined && (
        <button className="back-btn" onClick={() => setScreen(backTo)}>
          ‹ Tillbaka
        </button>
      )}
      <button
        className="theme-toggle"
        data-theme={theme}
        onClick={toggle}
        aria-label={theme === 'dark' ? 'Byt till ljust läge' : 'Byt till mörkt läge'}
      >
        <span className="theme-toggle-circle">
          <span className="theme-toggle-icon">{theme === 'dark' ? '🌙' : '☀️'}</span>
        </span>
      </button>
      {title !== undefined && (
        <div
          className="nav-title"
          style={compact || backTo === undefined ? { textAlign: 'center' } : undefined}
        >
          {title}
        </div>
      )}
      {right}
    </div>
  );
}
